import {
  EntitySwitch,
  isComponentType,
} from '@backstage/plugin-catalog';
import { serviceEntityPage } from './ServiceEntityPage';
import { websiteEntityPage } from './WebsiteEntityPage';
import { documentationEntityPage } from './DocumentationEntityPage';
import { defaultEntityPage } from './DefaultEntityPage';

export const componentPage = (
  <EntitySwitch>
    <EntitySwitch.Case if={isComponentType('service')}>
      {serviceEntityPage}
    </EntitySwitch.Case>

    <EntitySwitch.Case if={isComponentType('website')}>
      {websiteEntityPage}
    </EntitySwitch.Case>

    <EntitySwitch.Case if={isComponentType('documentation')}>
      {documentationEntityPage}
    </EntitySwitch.Case>

    <EntitySwitch.Case>{defaultEntityPage}</EntitySwitch.Case>
  </EntitySwitch>
);